import React from 'react';
import { InputGroup } from 'rsuite';
import NumberFormat from 'react-number-format';
import * as cs from '../common/common-styles';
import { DEFAULT_FORM_VALUE } from './constants';
import styled from 'styled-components';
export function MaskPhoneNumberInput(props) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      format="###-###-####"
      mask="_"
      onValueChange={({ value }) => onChange(value)}
    />
  );
}

function InputAdornment(props) {
  const { tooltipMessage, imageSrc, altText } = props;

  if (!imageSrc || !altText) return null;

  return (
    <InputGroup.Addon>
      <cs.BalloonTooltip aria-label={tooltipMessage} data-balloon-pos="up" >
        <img src={imageSrc} alt={altText} />
      </cs.BalloonTooltip>
    </InputGroup.Addon>
  );
}

const InputSection = styled.div`
  margin-top: ${(props) => props.noMargin ? 0 : '18px'};
  width: ${(props) => props.width ? props.width : '400px' };
`;

export function LabelledInput(props) {
  const { label, value, onChange, required, tooltipMessage, imageSrc, altText, width, noMargin, ...other } = props;

  return (
    <InputSection noMargin={noMargin} width={width}>
      <cs.InputTextFieldLabel>{label}</cs.InputTextFieldLabel>
      <InputGroup inside>
        <cs.StyledInput
          value={value || DEFAULT_FORM_VALUE}
          onChange={(value, e) => onChange(e)}
          required={required}
          {...other}
        />
        <InputAdornment tooltipMessage={tooltipMessage} imageSrc={imageSrc} altText={altText} />
      </InputGroup>
    </InputSection>
  );
}
